/**
 * autoReplyShadowApi — las decisiones de Auto Reply en sombra, y la opinión
 * humana sobre ellas.
 *
 * El GET devuelve una página de decisiones —lo que el bot habría contestado
 * en cada ráfaga, con su veredicto— más el resumen del histórico del lead.
 *
 * El POST **no envía nada**. Guarda una opinión y ahí se acaba: no enciende
 * SEND, no escribe en la base de conocimiento, no entrena nada y no toca el
 * lead. Es el equivalente de la revisión de CRM Intelligence — mide si lo
 * que hizo el modelo estuvo bien, no lo aplica.
 *
 * Fichero propio y no dentro de crmIntelligenceApi a propósito: aquella
 * frontera de escritura está cerrada por un test que cuenta sus `api.post`.
 */
import { api } from "./api";

/** Una página de decisiones, de la más reciente hacia atrás. */
export async function getAutoReplyDecisions(leadId, { limit, before } = {}) {
  const params = {};
  if (limit) params.limit = limit;
  if (before) params.before = before;
  const { data } = await api.get(`/leads/${leadId}/auto-reply/decisions`, {
    params,
  });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    next_before: data?.next_before || null,
    summary: data?.summary || null,
    shadow_enabled: data?.shadow_enabled === true,
  };
}

/**
 * La opinión de una persona sobre una decisión.
 *
 * Dos opiniones independientes, y basta una: `verdict` sobre el TEXTO
 * ("correct" / "incorrect", con `correctedText` y `category` opcionales) y
 * `actionVerdict` sobre la ACCIÓN, con `actionCategory`. El backend solo
 * guarda lo que llega: opinar de la acción no borra lo dicho del texto.
 */
export async function saveAutoReplyFeedback(
  leadId, decisionId,
  { verdict, correctedText, category, actionVerdict, actionCategory } = {}
) {
  const { data } = await api.post(
    `/leads/${leadId}/auto-reply/decisions/${decisionId}/feedback`,
    {
      verdict: verdict || null,
      corrected_text: correctedText || null,
      category: category || null,
      action_verdict: actionVerdict || null,
      action_category: actionCategory || null,
    }
  );
  return data?.feedback || null;
}
